/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current health status of the integration
 * @export
 */
export const ControlHealthStatus = {
    Healthy: 'healthy',
    Unhealthy: 'unhealthy',
    Unstable: 'unstable',
    Unknown: 'unknown'
} as const;
export type ControlHealthStatus = typeof ControlHealthStatus[keyof typeof ControlHealthStatus];


export function ControlHealthStatusFromJSON(json: any): ControlHealthStatus {
    return ControlHealthStatusFromJSONTyped(json, false);
}

export function ControlHealthStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlHealthStatus {
    return json as ControlHealthStatus;
}

export function ControlHealthStatusToJSON(value?: ControlHealthStatus | null): any {
    return value as any;
}

